export const RECENT_NEWS_LOAD_REQUEST = 'RECENT_NEWS_LOAD_REQUEST';
export const RECENT_NEWS_LOAD_SUCCESS = 'RECENT_NEWS_LOAD_SUCCESS';
export const RECENT_NEWS_LOAD_FAILURE = 'RECENT_NEWS_LOAD_FAILURE';
